<mat-expansion-panel hideToggle [disabled]="flujo.bloqueado" [expanded]="!flujo.ok && !flujo.cargando">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Declaración Jurada
    </mat-panel-title>
    <mat-panel-description>
      <div *ngIf="flujo.cargando">
        <div class="spinner-border text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div *ngIf="flujo.ok">
        <!--======ok menu ======-->
        <img src="assets/icons/icon-check.svg" alt="ok" />
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="row-resumen">
    <div *ngIf="flujo.ok">
      <div class="txt-info-uaf">
        <p>
          Declaración Jurada Completada
        </p>
    </div>
    </div>
    <div *ngIf="!flujo.ok">
      <app-messages class="informativo p-16" message="<strong>Para continuar debes completar la siguiente declaración jurada.</strong>"></app-messages>
      <div class="row-resumen-orden mt-16">
        <div class="txt-info-uaf">
            <p>
              La UAF (Unidad de Análisis Financiero) es un servicio público descentralizado que nos ayuda en la prevención y la detección de delitos financieros.
            </p>
            <p>
              Deberás completar con la información requerida de tu negocio y tus socias.
            </p>
        </div>
      </div>
    </div>
    <div class="col-md-6" [hidden]="flujo.ok">
      <input class="btn-primary-tbk" value="Completar" (click)="redireccionarFormulatioUaf()">
    </div>

  </div>

</mat-expansion-panel>
